function initBestDealsSlider(sectionId) {
    var root = document.querySelector('.bestdeals-section-' + sectionId);

    if (!root || root.dataset.bestDealsSliderReady === 'true') {
        return;
    }

    var slider = root.querySelector('#Slider-' + sectionId);
    var dots = Array.prototype.slice.call(
        root.querySelectorAll('.slider-counter__link[data-slide-index]')
    );

    if (!slider || !dots.length) {
        return;
    }

    function setActiveDot(index) {
        dots.forEach(function (dot, dotIndex) {
            var isActive = dotIndex === index;
            dot.classList.toggle('slider-counter__link--active', isActive);
            if (isActive) {
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.removeAttribute('aria-current');
            }
        });
    }

    dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
            var targetSlide = slider.querySelector(
                '#Slide-' + sectionId + '-' + (index + 1)
            );

            if (!targetSlide) {
                return;
            }

            slider.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: 'smooth',
            });
        });
    });

    root.addEventListener('slideChanged', function (event) {
        setActiveDot(event.detail.currentPage - 1);
    });

    setActiveDot(0);
    root.dataset.bestDealsSliderReady = 'true';
}